import {Button, Form, Input, Select, Space, Typography} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {t} from "i18next";

// Dynamic add/remove editor for ACK rules. Renders a Form.List, so it must live
// inside an antd <Form>. The form value at `name` is an array of
// { verdict, type, pattern } — serialize it with serializeRules() before sending.
export default function AckRuleEditor({name = 'ackRuleItems'}) {
    return (
        <>
            <Typography.Text type={'secondary'} style={{fontSize: 12, display: 'block', marginBottom: 8}}>
                {t('Rules are checked in order; the first matching rule decides. No rule / no match / invalid regex => success.')}
            </Typography.Text>

            <Form.List name={name}>
                {(fields, {add, remove}) => (
                    <>
                        {fields.map(({key, name: n, ...restField}) => (
                            <Space key={key} align={'baseline'} style={{display: 'flex', marginBottom: 8}}>
                                <Form.Item {...restField} name={[n, 'verdict']} initialValue={'ok'} noStyle>
                                    <Select
                                        style={{width: 110}}
                                        options={[
                                            {value: 'ok', label: t('Success')},
                                            {value: 'fail', label: t('Failed')}
                                        ]}
                                    />
                                </Form.Item>
                                <Form.Item {...restField} name={[n, 'type']} initialValue={'re'} noStyle>
                                    <Select
                                        style={{width: 120}}
                                        options={[
                                            {value: 're', label: 'Regex'},
                                            {value: 'has', label: t('Contains')}
                                        ]}
                                    />
                                </Form.Item>
                                <Form.Item {...restField} name={[n, 'pattern']} noStyle>
                                    <Input placeholder={'MSA\\|A[AC]\\|  ·  AA,rapor kaydedildi'} style={{width: 300}}/>
                                </Form.Item>
                                <MinusCircleOutlined onClick={() => remove(n)}/>
                            </Space>
                        ))}
                        <Button
                            type={'dashed'}
                            onClick={() => add({verdict: 'ok', type: 're', pattern: ''})}
                            block
                            icon={<PlusOutlined/>}
                        >
                            {t('Add Rule')}
                        </Button>
                    </>
                )}
            </Form.List>
        </>
    );
}
